import WireframeGlobe from './WireframeGlobe'

export default function WorldMap() {
  return (
    <>
      <div className="mt-10 font-mono text-[11px] tracking-[0.1em] text-[rgba(245,245,243,.4)] uppercase">Global coverage</div>
      <p className="mt-2.5 max-w-[520px] text-[1.05rem] leading-[1.5] text-[rgba(245,245,243,.7)]">Dedicated capacity, provisioned wherever the work is.</p>
      <div className="mt-9 flex justify-center">
        <WireframeGlobe />
      </div>
    </>
  )
}
